import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderCaptionComponent } from 'src/app/components/header-caption/header-caption.component';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { AuthComponent } from 'src/app/core/interfaces/auth-component.interface';
import { CompanyService } from 'src/app/services/company/company.service';
import { SsoService } from 'src/app/services/sso/sso.service';

@Component({
  selector: 'app-sso-error',
  standalone: true,
  imports: [CommonModule, TranslateModule, HeaderComponent, HeaderCaptionComponent],
  templateUrl: './sso-error.component.html',
  styleUrls: ['./sso-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SsoErrorComponent implements AuthComponent {
  private ssoService = inject(SsoService);
  private companyService = inject(CompanyService);
  private cdr = inject(ChangeDetectorRef);

  errorMessage = this.ssoService.errorMessage;
  isRedirecting = false;

  async redirectToSso(): Promise<void> {
    this.isRedirecting = true;
    this.cdr.markForCheck();

    try {
      const config = await firstValueFrom(this.ssoService.getSsoConfig(this.companyService.name));
      if (config.is_sso_used && config.sso_client_url) {
        this.ssoService.redirectToSso(config.sso_client_url);
      }
    } catch {
      this.isRedirecting = false;
      this.cdr.markForCheck();
    }
  }
}
